import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"

const Masthead = ({children}) => {
  const data = useStaticQuery(graphql`
  query{
    masthead: file(relativePath: { eq: "Header.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 4000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
     
      
  }
  `)
  return(
    <BackgroundImage className={`masthead image-text parallax`} data-speed={-2}  fluid={data.masthead.childImageSharp.fluid}>
      {children}
      <div className={'image-overlay'}/>
    </BackgroundImage>
  )
}


export default Masthead
